import { useState, useEffect } from "react";
import makeApi, { URLS } from "Utils/apiURL";
import Utils from "Utils/utils";

const useTeamMembersAndTeams = () => {
  const [members, setMembers] = useState([]);
  const [teams, setTeams] = useState([]);
  // Map<teamId, memberId[]> - which members belong to each team, so callers (the LinkedIn-account
  // filter in AudienceScopePopover) can narrow to a team's own members instead of the whole org.
  const [teamMembersMap, setTeamMembersMap] = useState(new Map());
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    makeApi({ url: URLS.getTeamData, method: "GET" })
      .then(res => {
        if (cancelled) return;
        const groups = res?.data?.groups || [];
        const teamMembers = res?.data?.teamMembers || [];
        const allMembers = [];
        const allTeams = [];
        const groupMemberIds = new Map();
        const addMember = m => {
          if (m?.memberId && !allMembers.some(existing => existing.memberId === m.memberId)) {
            allMembers.push({ memberId: m.memberId, name: Utils.getFullNameFromUserInfo(m) });
          }
        };
        groups.forEach(item => {
          const { group = {} } = item || {};
          const groupMembers = item?.members || [];
          if (group?.id) {
            allTeams.push({ id: group.id, name: group.name });
            groupMemberIds.set(group.id, groupMembers.map(m => m?.memberId).filter(Boolean));
          }
          groupMembers.forEach(addMember);
        });
        teamMembers.forEach(addMember);
        setMembers(allMembers);
        setTeams(allTeams);
        setTeamMembersMap(groupMemberIds);
      })
      .catch(err => console.error("useTeamMembersAndTeams: failed to load team members", err))
      .finally(() => !cancelled && setLoading(false));
    return () => { cancelled = true; };
  }, []);

  return { members, teams, teamMembersMap, loading };
};

export default useTeamMembersAndTeams;
